<template>
    <PopupRouterView :showLeftIcon="true" label="Job Position Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="jobposition"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="jobPositionInput">
        <b-card header="Job Position" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete 
						:options="userInfos" 
						optionsLabel="firstName" 
						optionsKey="userName" 
						label-cols-lg="12" 
						label="User" 
						id="fieldset-user-info" 
						size="sm" 
						:model.sync="model.userInfoUserName" 
						:isRequired="true" 
						:selected="model.userInfo != null ? model.userInfo.firstName : ''" 
						@input="getUserInfos"   
						:isSelectMethodExists="true" @onSelectMethod="setSelectedUserInfo" />
					<app-input-combobox-autocomplete 
						:options="approvalStructures" 
						optionsLabel="name" 
						optionsKey="id" 
						label-cols-lg="12" 
						label="Job Position" 
						id="fieldset-approval-structure" 
						size="sm" 
						:model.sync="model.approvalStructureId" 
						:isRequired="true" 
						:selected="model.approvalStructure != null ? model.approvalStructure.name : ''" 
						@input="getApprovalStructures"   
						:isSelectMethodExists="true" 
						@onSelectMethod="setSelectedApprovalStructure"
						 />
				</b-col>
				<b-col cols="12" lg="6">
				</b-col>
            </b-row>
        </b-card>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import JobPosition from '@/models/JobPosition/JobPosition';
import JobPositionList from '@/models/JobPosition/JobPositionList';
import JobPositionFilter from '@/filters/JobPosition/JobPositionFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
	components : {
		AppInputComboboxAutocomplete,
		PopupRouterView,
		AppInputTextbox,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
				userInfoUserName: { required : "User is Required."},
				approvalStructureId: { required : "Job Position is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterJobPosition : null,
			currentJobPositionPage : 1,
			jobPositionPageSize: 10,
			sortByJobPosition: '',
			sortDescJobPosition: '',
			userInfos: [],
			userInfos: [],
			isUserInfoComboLoading: false,
			approvalStructures: [],
			approvalStructures: [],
			isApprovalStructureComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isUserInfoComboLoading: false,
			isApprovalStructureComboLoading: false,
		}
	},
	methods : {
		getJobPosition : async function(id) {
			this.isBusy = true;
			JobPosition.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadJobPosition = true;
			this.filterJobPosition.id = this.modelId;
			JobPosition.downloadDataDetail(this, this.filterJobPosition).then(result => {
				this.isDownloadJobPosition = false;
			}).catch(error => { this.isDownloadJobPosition = false; })
		},
		getJobPositions : async function(input) {
			let filter = new JobPositionFilter();
			if (input != undefined) {
				filter.UserInfo = input;
			}
			this.isJobPositionComboLoading = true;
			JobPosition.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.jobPositions = result.data
				}
				this.isJobPositionComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedUserInfo(item) {
			if(item == undefined || item == null) {
				this.model.userInfoUserName = null;
				this.model.userInfo = null;
			} else {
				this.model.userInfoUserName = item.userName;
				this.model.userInfo = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedApprovalStructure(item) {
			if(item == undefined || item == null) {
				this.model.approvalStructureId = null;
				this.model.approvalStructure = null;
			} else {
				this.model.approvalStructureId = item.id;
				this.model.approvalStructure = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			console.log('name: ', name)
			console.log('model', this.model);
			console.log('this.$v.model', this.$v.model)
			console.log('this.$v.model[name]', this.$v.model[name])
			console.log('----------')

			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			let result = $dirty ? !$error : null;
			console.log('result:', result)
			return result;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.jobPositionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						JobPosition.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'jobpositionindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						JobPosition.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'jobpositionindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					JobPosition.updateData(this, model, id)
					.catch((error) => {
						this.getJobPosition(id);
					});
				}
			});
		},
		onHidden() {
			this.getJobPositions();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterJobPosition = new JobPositionFilter();
		//this.getUserInfos();
		//this.getApprovalStructures();
	},
	async mounted(){
		let id = this.$route.params.id;

		console.log('model:::', this.model);
		console.log('v-model:::', this.$v.model);

		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getJobPosition(id);
			} else {
				this.modelId = id;
				this.getJobPosition(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		},
	},
	watch : {
	},
}
</script>
